import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();

export default async function getAllSalesAgents() {
	var salesAgentsArr = [];

	await firebaseRef
		.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/salesAgents/')
		.once('value', (snapshot) => {
			var salesAgentsParents = snapshot.val();

			console.log('salesAgentsParents', salesAgentsParents);

			var salesAgentsKeys = Object.keys(salesAgentsParents);

			console.log('salesAgentsKeys', salesAgentsKeys);

			var salesAgentObj;

			salesAgentsKeys.forEach((key) => {
				var salesAgentId = salesAgentsParents[key]['createrID'];
				var salesAgentEmail = salesAgentsParents[key]['email'];
				var salesAgentName = salesAgentsParents[key]['name'];

				console.log('salesAgentKey', salesAgentId);

				salesAgentObj = {
					salesAgentId: salesAgentId,
					salesAgentName: salesAgentName,
					salesAgentEmail: salesAgentEmail,
				};

				salesAgentsArr.push(salesAgentObj);
			});
		});

	console.log('salesAgentsArr', salesAgentsArr);

	return salesAgentsArr;
}
